module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/test-ab763b959a604f6d5b42a363b3efb74d.jpg";